const pll = {
    prevSlideMessage: 'Go to previous slide',
    nextSlideMessage: 'Go to next slide',
    firstSlideMessage: 'This is the first slide',
    lastSlideMessage: 'This is the last slide',
    paginationBulletMessage: 'Go to slide {{index}}'
};

export default pll;